import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import {
  Explainer,
  ExplainerBody,
  ExplainerContent,
  ExplainerCopy,
  ExplainerTitle,
  ExplainerTrigger,
} from './Explainer';

export const DeforestationExplainer = () => {
  const { t } = useTranslation();

  return (
    <Explainer>
      <ExplainerTrigger data-testid='deforestation-explainer'>{t('global.howDoWeMeasureThis')}</ExplainerTrigger>
      <ExplainerContent>
        <ExplainerTitle>{t('shared.ncaDetail.details.deforestation.explainers.howDoWeMeasure.title')}</ExplainerTitle>
        <Stack spacing={8} className='items-start pb-6'>
          <ExplainerBody className='pb-0'>
            <ExplainerCopy body={t('shared.ncaDetail.details.deforestation.explainers.howDoWeMeasure.body')} />
          </ExplainerBody>
        </Stack>
      </ExplainerContent>
    </Explainer>
  );
};
